import gql from 'graphql-tag';

export const CalendarsDetailsQuery = gql`
	query CalendarsDetailsQuery($viewingSpaceKey: ID, $include: [String!], $calendarContext: String!)
	@experimental {
		experimentalTeamCalendars(
			viewingSpaceKey: $viewingSpaceKey
			include: $include
			calendarContext: $calendarContext
		) {
			payload {
				reminderMe
			}
			success
		}
		experimentalCurrentUser {
			timeZone
		}
		experimentalSystemInfoSettings {
			defaultTimeZone
		}
	}
`;
